import React from "react";

function Color_Wheels() {
  return (
    <div>
      <h1>Color_Wheels Component</h1>
      <p>This is the Color Wheels tutorial page content.</p>
    </div>
  );
}

export default Color_Wheels;
